const private_network = {
	index: {
		empty: {
			description: "Ihr Konto verfügt noch nicht über private Netzwerke.",
			title: "Keine privaten Netzwerke gefunden...",
		},
		notifications: {
			create:
				"Das private Netzwerk <strong>{{name}}</strong> wird erstellt... Dies kann einen Moment dauern.",
			create_already_existing:
				"Das private Netzwerk <strong>{{name}}</strong> kann nicht erstellt werden. Dieser Name ist bereits in Verwendung.",
			delete: "Das private Netzwerk <strong>{{name}}</strong> wurde erfolgreich gelöscht.",
			update: "Das private Netzwerk <strong>{{name}}</strong> wurde erfolgreich geändert.",
			update_already_existing:
				"Das private Netzwerk <strong>{{name_current}}</strong> kann nicht geändert werden. Es gibt bereits ein privates Netzwerk mit dem Namen <strong>{{name_new}}</strong>.",
		},
		search: {
			label: "Privates Netzwerk suchen",
			placeholder: "Netzwerk X",
		},
		title: "Übersicht über private Netzwerke",
	},
	management: {
		dialog_create: {
			description: "Fügen Sie hier Ihr neues privates Netzwerk hinzu.",
			title: "Privates Netzwerk hinzufügen",
		},
		dialog_delete: {
			description: `Sind Sie sicher, dass Sie das private Netzwerk <strong>{{name}}</strong> löschen möchten? 
                <br/>
                <br/>
                <strong>Achtung!</strong>
                Alle verbundenen VPS werden getrennt, und die überflüssigen Schnittstellen werden aus diesen VPS entfernt.`,
			title: "Privates Netzwerk löschen",
		},
		dialog_qemu_connect: {
			button: "VPS auswählen",
			description:
				"Wählen Sie eine Ihrer VPS aus, die noch nicht mit einem Netzwerk verbunden ist.",
			no_internet_connection: "Keine Internetverbindung",
			title: "VPS zum Netzwerk hinzufügen",
		},
		dialog_qemu_delete: {
			description:
				"Sind Sie sicher, dass Sie die VPS <strong>{{name}}</strong> aus dem Netzwerk entfernen möchten?",
			title: "VPS aus dem Netzwerk entfernen.",
		},
		dialog_qemu_select: {
			costs: "Preis € {{costs}} pro Monat",
			description:
				"Hier finden Sie die VPS, die mit dem privaten Netzwerk verbunden werden können.",
			empty: {
				title: "Keine verfügbaren VPS gefunden.",
				tooltip:
					"Es wurden keine VPS gefunden, die noch nicht mit einem privaten Netzwerk verbunden sind. Entfernen Sie zuerst VPS aus einem anderen privaten Netzwerk oder fügen Sie neue VPS hinzu.",
			},
			title: "Verfügbare VPS auswählen",
		},
		info: {
			title: "Eigenschaften",
		},
		notifications: {
			create: "Die ausgewählten VPS wurden erfolgreich dem privaten Netzwerk hinzugefügt.",
			delete: "VPS <strong>{{name}}</strong> wurde erfolgreich aus dem Netzwerk entfernt.",
		},
		qemus: {
			description:
				"Verknüpfen Sie VPS miteinander über ein privates Netzwerk. Das VPS erhält dafür eine separate Netzwerkschnittstelle. VPS, die sich im selben Netzwerk befinden, können miteinander kommunizieren. Sie müssen nur IP-Adressen auf dieser internen Schnittstelle konfigurieren.",
			table: {
				connection: ["Ja", "Nein"],
				empty: "Keine VPS im Netzwerk gefunden.",
				header: ["VPS", "Status", "Internetverbindung?"],
				status: ["Läuft", "Gestoppt"],
			},
			title: "VPS in Netzwerk",
		},
		title: "Privates Netzwerk",
	},
	overview_card: {
		description: "Beschreibung",
		name: "Name",
	},
};

export default private_network;
